module.exports = __webpack_public_path__ + "img/016.c277aaed.jpg";